import { AxiosProgressEvent } from 'axios';
import API from 'services/api.js';
import { URL_YARD_WTS } from 'services/urls.js';

export const actionUploadYardWtFile = async (
	file: File,
	filename: string,
	clientId: number,
	uploadProgress: (progressEvent: AxiosProgressEvent) => void
): Promise<{ success: boolean; msg: string }> => {
	if (clientId < 1) {
		console.log('Invalid client id : ' + clientId);
		return { success: false, msg: 'Client ID not set' };
	}
	const formData = new FormData();
	formData.append('file', file);
	formData.append('filename', filename);
	const config = {
		params: { clientId: clientId },
		headers: {
			// Overwrite Axios's automatically set Content-Type
			'Content-Type': 'multipart/form-data',
		},
		onUploadProgress: uploadProgress,
	};
	try {
		const response = await API.post(URL_YARD_WTS, formData, config);
		console.log('response', response.data[0]);
		return response.data[0];
	} catch (error) {
		console.log('ERR actionUploadYatdWtFile: ', error);
	}
	return { success: false, msg: 'Unknown error' };
};
